import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  startDate?: string;
  endDate?: string;
  year?: string;
}

export const useGenerateCBAMReport = () => {
  return useMutation({
    mutationFn: async ({ startDate, endDate, year }: HookProps) => {
      const result = await apiClient.batchesReports.generateCbamReport.mutation({ body: { startDate, endDate, year } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      toast.success('The CBAM report is being generated.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the CBAM report!');
    },
  });
};
